// 📄 pages/Home/TusOrganizaciones.tsx
// Organizaciones en Inicio (2026-10-26): antes solo se cambiaban desde el
// selector de arriba a la derecha y quien recién era invitado a un equipo
// no se enteraba de que tenía que cambiar. Con una sola org se muestra
// solo el nombre (como antes); con varias, una tarjeta por org para
// cambiar con un clic. Además avisa de los equipos nuevos (orgsNuevas).
import React from 'react';
import { Users as UsersIcon, User as UserIcon, Check, Archive, PartyPopper, X, ArrowRight } from 'lucide-react';
import { useAuth } from '../../context/AuthContext.tsx';

const ROLE_LABELS: Record<string, string> = {
  owner: 'Owner',
  admin: 'Admin',
  miembro: 'Miembro',
  invitado: 'Invitado'
};

export default function TusOrganizaciones() {
  const { organizations, orgActual, setOrgActual, orgsNuevas, marcarOrgsConocidas } = useAuth();
  if (!orgActual) return null;

  const aviso = orgsNuevas[0];

  return (
    <div className="w-full max-w-4xl mb-1 space-y-3">
      {aviso && (
        <div className="flex flex-col sm:flex-row sm:items-center gap-3 rounded-xl border border-indigo-500/30 bg-indigo-500/10 px-4 py-3">
          <PartyPopper className="w-5 h-5 text-indigo-300 flex-shrink-0" />
          <p className="flex-1 text-sm text-gray-200">
            Te agregaron a <strong className="text-white">{aviso.name}</strong> como {ROLE_LABELS[aviso.role] || aviso.role}.
            {orgsNuevas.length > 1 && ` (y a ${orgsNuevas.length - 1} organización${orgsNuevas.length > 2 ? 'es' : ''} más)`}
          </p>
          <div className="flex items-center gap-2">
            <button
              onClick={() => setOrgActual(aviso.id)}
              className="flex items-center gap-1.5 bg-indigo-600 hover:bg-indigo-500 px-3 py-1.5 rounded-lg text-sm font-semibold text-white transition-all"
            >
              Ir ahora <ArrowRight className="w-4 h-4" />
            </button>
            <button onClick={marcarOrgsConocidas} className="p-1.5 rounded-lg text-gray-400 hover:text-white hover:bg-white/10" title="Cerrar aviso">
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}

      {organizations.length <= 1 ? (
        <div className="flex items-center gap-2 text-sm text-gray-400">
          <UsersIcon className="w-3.5 h-3.5" />
          <span>Organización activa: <span className="text-white font-medium">{orgActual.name}</span></span>
        </div>
      ) : (
        <div>
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">Tus organizaciones</p>
          <div className="flex gap-2 overflow-x-auto pb-1">
            {organizations.map((org) => {
              const activa = org.id === orgActual.id;
              return (
                <button
                  key={org.id}
                  onClick={() => setOrgActual(org.id)}
                  className={`flex-shrink-0 flex items-center gap-2.5 min-w-[11rem] max-w-[16rem] rounded-xl border px-3 py-2.5 text-left transition-all ${
                    activa
                      ? 'border-indigo-500/60 bg-indigo-500/10'
                      : 'border-white/10 bg-white/5 hover:border-indigo-500/40 hover:bg-white/10'
                  }`}
                  title={activa ? 'Organización activa' : `Cambiar a ${org.name}`}
                >
                  {org.type === 'personal' ? (
                    <UserIcon className="w-4 h-4 flex-shrink-0 text-gray-500" />
                  ) : (
                    <UsersIcon className="w-4 h-4 flex-shrink-0 text-indigo-400" />
                  )}
                  <span className="flex-1 min-w-0">
                    <span className={`block truncate text-sm font-medium ${activa ? 'text-indigo-300' : 'text-white'}`}>{org.name}</span>
                    <span className="flex items-center gap-1 text-[10px] font-semibold text-gray-500 uppercase tracking-wide">
                      {ROLE_LABELS[org.role] || org.role}
                      {org.archivada && <><Archive className="w-3 h-3 ml-1" /> Archivada</>}
                    </span>
                  </span>
                  {activa && <Check className="w-4 h-4 flex-shrink-0 text-indigo-300" />}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
